module.exports = __webpack_public_path__ + "img/w3_bookmark_square_grey.c0a8ecee.png";